<template>
  <div id="games">
    <v-item-group mandatory>
      <div>
        <v-row v-if="categories.length > 1">
          <v-col cols="12" sm="8">
            <v-chip-group
                v-model="selectedCategory"
                active-class="primary"
                mandatory
                class="justify-content-start"
            >
              <v-chip outlined active @click="filterByCategory('')">
                {{ $t('All') }}
              </v-chip>
              <v-chip v-for="category in categories" :key="category" outlined @click="filterByCategory(category)">
                {{ $t(category) }}
              </v-chip>

            </v-chip-group>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
                class=""
                prepend-inner-icon="mdi-magnify"
                :label="$t('Search')"
                v-model="search"
                outlined
                dense
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row ref="games" class="justify-start">
          <template v-for="(game, id) in searchGame">
            <v-col
                v-if="!config(game.id + '.variations')"
                :key="game.id"
                cols="12"
                sm="6"
                lg="3"
                :data-groups="JSON.stringify(config(game.id + '.categories') || [])"
                class="game-card"
            >
              <game-card :id="game.id" :name="game.name" :banner="config(game.id + '.banner')"/>
            </v-col>

            <template v-else>
              <v-col
                  v-for="variation in config(game.id + '.variations')"
                  :key="variation.slug"
                  cols="12"
                  sm="6"
                  lg="3"
                  :data-groups="JSON.stringify(variation.categories || [])" class="game-card"
              >
                <game-card :id="game.id" :name="variation.title" :slug="variation.slug" :banner="variation.banner"/>
              </v-col>
            </template>
          </template>
        </v-row>

      </div>
    </v-item-group>
  </div>
</template>

<script>

import {config} from '~/plugins/config'
import {mapGetters} from "vuex";
import Shuffle from "shufflejs";
import GameCard from './GameCard'
import {
  hasLotteryEnabled,
  hasSportsBetEnabled,
} from '~/plugins/config'

export default {
  components: {GameCard},

  data() {
    return {
      selectedCategory: '',
      shuffle: null,
      search: '',
      model: 1,
    }
  },
  computed: {
    ...mapGetters({
      games: 'package-manager/games'
    }),
    categories() {
      let categories = []

      Object.keys(this.games).forEach(id => {
        const variations = config(id + '.variations')
        if (variations) {
          variations.forEach(variation => {
            categories = categories.concat(variation.categories)
          })
        } else {
          categories = categories.concat(config(id + '.categories'))
        }
      });
      // remove duplicates
      return categories.filter((category, i) => category && categories.indexOf(category) === i)
    },


    searchGame() {
      const sportsBetIndex = this.games['sports-bet']
      if (this.search === '') {
        return this.organizeGamesArray(Object.entries(this.games)
            .filter(([key, game]) => {
              if ((key == 'sports-bet' && !hasSportsBetEnabled()) || (key == 'lottery' && !hasLotteryEnabled())) {
                return false
              } else {
                return true
              }
            })
            .map(([key, game]) => ({...game, id: key})));
      } else {
        return this.organizeGamesArray(Object.entries(this.games)
            .map(([key, game]) => ({...game, id: key}))
            .filter(game => game.name.toLowerCase().includes(this.search.toLowerCase()))
        );
      }
    },
  },

  methods: {
    config,
    filterByCategory(category) {
      if (!this.shuffle) {
        this.shuffle = new Shuffle(this.$refs.games, {itemSelector: '.game-card'})
      }
      this.shuffle.filter(category)
    },
    organizeGamesArray(games) {
      games.forEach(function (item, i) {
        if (item.id === "sports-bet" || item.id === "lottery") {
          games.splice(i, 1);
          games.unshift(item);
        }
      });
      return games
    }
  }
}
</script>

<style lang="scss" scoped>


</style>


